export var User
export var firstName
export var lastName
export var Rol
export var Dependence
export var logo_map
export var visor_id
export var dependence_id
export var Tipo_rol
export var refresh_token
export var user_id

export var herramientas
export var Token

export var nombre_municipio = ''
export var codigo_municipio = ''
export var id_plataforma = ''
export var nombre_plataforma = ''



export function actualizarVariables() {
    User = sessionStorage.getItem('User');
    firstName = sessionStorage.getItem('user-firstName');
    lastName = sessionStorage.getItem('user-lastName');
    Rol = sessionStorage.getItem('rol');
    Dependence = sessionStorage.getItem('dependence');
    dependence_id = sessionStorage.getItem('dependence-id');
    Tipo_rol = sessionStorage.getItem('tipo-rol')
    refresh_token = sessionStorage.getItem('refresh-token')
    herramientas = sessionStorage.getItem('herramientas')
    Token = sessionStorage.getItem('token-access')
    visor_id = sessionStorage.getItem('id-plataforma')
    user_id = sessionStorage.getItem('user_id')


    nombre_municipio = sessionStorage.getItem('nombre-municipio')
    codigo_municipio = sessionStorage.getItem('codigo-municipio')
    id_plataforma = sessionStorage.getItem('id-plataforma')
    nombre_plataforma = sessionStorage.getItem('nombre-plataforma')
}

